import React from "react";
import TmsRandomJob from "components/TmsRandomJob";
import {render} from "react-dom";
import {createRoot} from "react-dom/client";
import TmsJoblist from "./components/TmsJoblist";
// import "./components/TmsRandomJob/TmsRandomJob.scss";

let app;

// export function version() {
//     console.info('version:', '2.0.1', 'codename:', 'phoenix')
// }

export function init(configObject) {
    const tagList = document.querySelectorAll("tms-randomjob");
    const randomJob = <TmsRandomJob />;

    for (let i = 0; i < tagList.length; i++) {
        // app = render(tagList.length > 10 ? errorhandler : randomJob, tagList[i]);
        app = createRoot(tagList[i]);
        app.render(randomJob);
    }
    // const app = render(<TmsJoblist setFilter />, tag);
}
